<div class="cursor-pointer flex-row gap-8">
  @if (article()) {
    <ng-template #popover let-close="close">


      @if (!noAction()) {
        <div class="border-8 up-4 container-background-reverse-alt p-12 flex-col gap-12 border-primary">
          <div class="flex-col w100">
            <div class="flex-row w100">
              <mat-icon class="ml-auto" (click)="close?.()">close</mat-icon>
            </div>
            <div class="flex-col gap-4">
                <span class="on-background-reverse">
          @if (article()?.bio) {
            <vl-bio-logo/>
          }
                  {{ article().denomination }}</span>
              <span class="on-background-reverse-alt body-2">{{ article().code }}</span>
            </div>
          </div>
          <div class="flex-col gap-4 w-36 wrap">
            @if (article()?.withTraca) {
              <vl-chips state="warn" size="small" cursor="default">Traça</vl-chips>
            }
            @if (article()?.withPiedDeChaine) {
              <vl-chips state="primary" size="small" cursor="default">PDC</vl-chips>
            }
            @if (article()?.withConsoTraca) {
              <vl-chips state="warn" size="small" cursor="default">Consos</vl-chips>
            }
            @if (!article()?.withConsoTraca && !articleInfos()?.withPiedDeChaine) {
              <vl-chips state="secondary" size="small" cursor="default">Auto</vl-chips>
            }
          </div>
          <vl-big-button (action)="this.goToArticle()" class="w100" [text]="'article.goToArticle' | trans"
                         icon="link"
                         color="accent"/>
          <vl-big-button (action)="onStats()" class="w100" [text]="'data.stats' | trans" icon="query_stats"
                         color="accent"/>

          <vl-big-button class="w100" color="accent"
                         icon="123"
                         (action)="goToComptage()"
                         [text]="'lot.count' | trans"/>

          <vl-big-button class="w100"
                         icon="package_2"
                         (action)="onStock()"
                         [text]="'data.lots' | trans" color="accent"/>
        </div>
      }
    </ng-template>
    <div class="flex-row gap-8">
      @if (image) {
        @if (article().photo) {
          <vl-doc-local
            class="flex-container m-auto"
            [docId]="article().photo"
            width="40px"
            height="40px"
            [readOnly]="true"
          ></vl-doc-local>
        } @else {
          <!-- Fallback : logo Justup coloré dérivé de l'articleId, pattern
               aligné sur article-action-card / commande-client-card / OF list. -->
          <vl-just-logo
            class="flex-container m-auto"
            [colorId]="article().articleId"
            [simple]="true"
            height="40px"
            width="40px"/>
        }
      }
    </div>
    <div class="flex-container justify-center"
         [closeOnClickOutside]="true"
         [popoverTrigger]="popover">
      @if (big()) {
        <span class="article-denomination subheading-2 on-background"
              [ngClass]="white() ? 'on-background-reverse' : 'on-background'">
          @if (article().bio) {
            <vl-bio-logo/>
          }
          {{ article().denomination }}</span>
      } @else {
        <span class="article-denomination caption-2"
              [ngClass]="white() ? 'on-background-reverse' : 'on-background'">
          @if (article().bio) {
            <vl-bio-logo size="small"/>
          } {{ article().denomination }}</span>
      }
      @if (ref()) {
        <span class="tiny" [ngClass]="white() ? 'on-background-reverse-alt' : 'on-background-alt'">{{ article().code }}</span>
      }
    </div>


  }
</div>
